import React, { Component } from 'react';

import socialHttp from '../../../../utils/socialHttp';

class SetNotifications extends Component {
	constructor(props) {
		super();

		this.state = {
			no_notifications: props.no_notifications,
		};

		this.setNotifications = this.setNotifications.bind(this);
	}

	componentWillUnmount() {
		this.unmounted = true;
	}

	setNotifications(event) {
		const value = !this.state.no_notifications;

		socialHttp(
			'put',
			'/data/relationships/' + this.props.obj + '/notifications',
			{
				no_notifications: value,
			}
		).catch((e) => {
			throw e;
		});

		this.setState({ no_notifications: value });
	}

	render() {
		return (
			<div>
				<div onClick={this.setNotifications}>
					<i className='fas fa-bell'></i>&nbsp;
					{this.state.no_notifications
						? 'Turn on notifications'
						: 'Turn off notifications'}
				</div>
			</div>
		);
	}
}

export default SetNotifications;
